import React from 'react';

function Page1() {
  return (
    <div className="page-container">
      <div className="row">
        <div className="col-12">
          <h2>Page 1</h2>
          <p className="text-muted">This is a private page accessible only after login.</p>
          <hr />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">External Content</h5>
              <p className="card-text">
                You can embed external websites using iframes below.
              </p>
              <div className="ratio ratio-16x9">
                <iframe
                  src="https://www.example.com"
                  title="External content"
                  allowFullScreen
                  sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Page1;
